import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { map, take } from 'rxjs/operators';

export const adminGuard: CanActivateFn = () => {
  const partnerSvc = inject(PartnerService);
  const router     = inject(Router);

  return partnerSvc.currentPartner$().pipe(
    take(1),
    map(partner => {
      if (partner?.isAdmin) return true;
      router.navigate(['/dashboard']);
      return false;
    })
  );
};
